export default __webpack_public_path__ + "static/Demo_German_Accent_British-e6f4566bb8fc5ae9673b53bbde2953c0.mp3";